import { useTranslation } from "@harea/component"
import { useTimeOffTypeQuery } from "./useTimeOffTypeQuery"

const MATERNITY_TYPES = ['MATERNAL', 'MATERNAL_ASSISTANCE']
const PATERNITY_TYPES = ['PATERNAL']

export const useTimeOffTypeList = (dayoffType?: TTimeOffTypeProps, gender?: TGender) => {
    const { data: timeOffTypes } = useTimeOffTypeQuery(true)
    const t = useTranslation()

    const isFemale = gender === 'FEMALE'
    const isMale = gender === 'MALE'

    const filterByGender = (types: any[]) => {
        if (isFemale) {
            return types.filter(type => !PATERNITY_TYPES.includes(type.designation))
        }
        if (isMale) {
            return types.filter(type => !MATERNITY_TYPES.includes(type.designation))
        }
        return types
    }

    if(dayoffType === 'LEAVE') {
        return filterByGender(timeOffTypes?.filter(type => type.designation !== 'ABSENCE') || [])?.map(type => ({
            id: type.id,
            label: t(`Generic.de.${type.designation}`),
            value: type.designation,
            isPaid: type.isPaid
        })) || []
    }

    if(dayoffType === 'MISSING') {
        return timeOffTypes?.filter(type => type.designation === 'ABSENCE')?.map(type => ({
            id: type.id,
            label: t(`Generic.de.${type.designation}`),
            value: type.designation,
            isPaid: type.isPaid
        })) || []
    }

    return filterByGender(timeOffTypes || [])?.map(type => ({
        id: type.id,
        label: t(`Generic.de.${type.designation}`),
        value: type.designation,
        isPaid: type.isPaid
    })) || []
}

type TTimeOffTypeProps = 'LEAVE' | 'MISSING'
type TGender = 'MALE' | 'FEMALE' | 'UNKNOWN' | null | undefined